export default "__VITE_ASSET__oIzmlda3__$_?url__"